import { Fab } from "@mui/material"
import React, { Fragment } from "react"
import { Link, useLocation } from "react-router-dom"

const InfoActionButton = ({ link = "" }) => {
	const location = useLocation()
	return (
		<Fragment>
			<Link to={location.pathname + link} className="no-underline">
				<Fab color="info" variant="action" aria-label="info">
					<i className="bi bi-info-lg !text-lg" />
				</Fab>
			</Link>
		</Fragment>
	)
}

export default InfoActionButton
